<template>
  <section
    class="promotion-detail"
    @click="bodyClick">
    <div class="header">
      <h1>Promotion</h1>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="flex border-box">
        <div class="half">
          <el-form-item
            ref="data.en.cover_image_file_id"
            prop="data.en.cover_image_file_id"
            :rules="rules.img_upload">
            <span>Image (English)</span>
            <v-upload
              :card="true"
              :notUpload="true"
              :otherData="{
                lang: 'en'
              }"
              :fileData='fileData.en'
              @uploadForm="handlerUploadSuccess"
            />
          </el-form-item>
          <el-form-item
            ref="data.en.title"
            :rules='rules.title'
            prop="data.en.title">
            <span>Title (English)</span>
            <v-input v-model="formData.data.en.title"></v-input>
          </el-form-item>
          <el-form-item
            ref="data.en.content"
            :rules='rules.content'
            prop="data.en.content">
            <span>Content (English)</span>
            <v-input
              v-model="formData.data.en.content"
              type='textarea'
              :rows='5'></v-input>
          </el-form-item>
        </div>
        <div class="half">
          <el-form-item
            ref="data.hk.cover_image_file_id"
            prop="data.hk.cover_image_file_id"
            :rules="rules.img_upload">
            <span>Image (Traditional Chinese)</span>
            <v-upload
              :card="true"
              :notUpload="true"
              :otherData="{
                lang: 'hk'
              }"
              :fileData='fileData.hk'
              @uploadForm="handlerUploadSuccess"
            />
          </el-form-item>
          <el-form-item
            ref="data.hk.title"
            :rules='rules.title'
            prop="data.hk.title">
            <span>Title (Traditional Chinese)</span>
            <v-input v-model="formData.data.hk.title"></v-input>
          </el-form-item>
          <el-form-item
            ref="data.hk.content"
            :rules='rules.content'
            prop="data.hk.content">
            <span>Content (Traditional Chinese)</span>
            <v-input
              v-model="formData.data.hk.content"
              type='textarea'
              :rows='5'></v-input>
          </el-form-item>
        </div>
      </div>
      <div class="flex border-box">
        <div class="half">
          <div
            v-for="(val,i) in typeList"
            :key="i"
          >
            <div class="flex">
              <span
                :class="[formData.type == i+3 ? 'radio-circle-checked': 'radio-circle']"
                @click="changeType(i+3)"></span>
              <el-form-item
                :prop="i+3 == 3 ? 'mate.url_en': i+3 == 5 ? 'mate.product_id' : 'mate.coupon_code'"
                :rules="i+3 == 3 ? rules.url : i+3 == 5 ? rules.product : rules.coupon_code"
                class="flex-right form-item">
                <span>{{val.title}}</span>
                <v-input
                  v-if="i+3 == 3"
                  ref="mate.url_en"
                  v-model="formData.mate.url_en"></v-input>
                <v-select
                  v-if="i+3 == 4"
                  ref="mate.coupon_code'"
                  v-model="formData.mate.coupon_code"
                  placeholder="Coupon Title - COUPONCODE"
                  remote
                  noList
                  :remoteMethod="remoteMethod"
                  :list="useCouponList"
                  :labelKey="'title'"
                  :labelSecondKey="'coupon_code'"
                  :valueKey="'coupon_code'"
                  @focus="handleFocus"></v-select>
                <v-select
                  v-if="i+3 == 5"
                  ref="mate.product_id"
                  v-model="formData.mate.product_id"
                  :list="couponOptionList"></v-select>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="half">
          <el-form-item
            ref="mate.url_hk"
            prop="mate.url_hk"
            :rules='rules.url'>
            <span>Destination URL (Traditional Chinese)</span>
            <v-input v-model="formData.mate.url_hk"></v-input>
          </el-form-item>
          <el-form-item
            v-if="classList.length"
            ref="mate.class_id"
            prop="mate.class_id"
            :rules='rules.product'
            class="classList">
            <span>Class</span>
            <v-select
              v-model="formData.mate.class_id"
              :list="classList"></v-select>
          </el-form-item>
        </div>
      </div>
      <div class="border-box">
        <div class="half">
          <el-form-item
            ref="tag_ids"
            class="form-item clear tag"
            prop="tag_ids"
            :rules="rules.tag">
            <span>Tags</span>
            <input-tag
              ref="input-tag"
              :tagIds="tags"
              @getTag="getTag"></input-tag>
          </el-form-item>
          <el-form-item
            ref="date"
            class="form-item"
            prop="date">
            <span>Promotion Period</span>
            <v-date-picker
              v-model="formData.date"
              format='dd-MM-yyyy'
              type="daterange"
            />
          </el-form-item>
          <div
            class="flex form-item">
            <v-checkbox
              v-model="formData.private"
              :isBoolean="false">
            </v-checkbox>
            <span
              class="cb_tips"
              @click="handleSetPrivate">Set this promotion as private</span>
          </div>
        </div>
      </div>

      <div class="btn-group flex-sb">
        <v-button @click="handleCancel">Cancel</v-button>
        <div>
          <v-button
            v-if="isDetail"
            type="danger"
            @click="handleDel">Delete</v-button>
          <v-button
            type="success"
            @click="handleSave">Save</v-button>
        </div>
      </div>
    </el-form>
  </section>
</template>

<script>
import { getUseCouponList, couponOption } from '@/api/coupon'
import { changePromotion, uploadNewsImage, getPromotionDetail } from '@/api/news'
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import InputTag from './components/input-tag.vue'
export default {
  name: 'proDetail',
  components:{
    InputTag
  },
  mixins: [MixinRules, MixinOptions],
  data () {
    const checkUrlRequired = (rule, value, callback) => {
      if(this.formData.type == 3){
        if(!value){
          callback(new Error(this.$t('placeholder.input')))
        }
      }
      callback()
    }
    const checkCouponRequired = (rule, value, callback) => {
      if(this.formData.type == 4){
        if(!value){
          callback(new Error(this.$t('placeholder.select')))
        }
      }
      callback()
    }
    const checkProductRequired = (rule, value, callback) => {
      if(this.formData.type == 5){
        if(!value || value == -1){
          callback(new Error(this.$t('placeholder.select')))
        }
      }
      callback()
    }
    const checkImg = (rule, value, callback) => {
      if(!value){
        callback(new Error(this.$t('placeholder.upload')))
      }
      callback()
    }
    const checkTag = (rule, value, callback) => {
      if(!value.length){
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      typeList: [
        {
          type: 3,
          title: 'Destination URL (English)'
        },
        {
          type: 4,
          title: 'Coupon'
        },
        {
          type: 5,
          title: 'Product'
        },
      ],
      fileData: {
        en: {},
        hk: {}
      },
      formData: {
        date: [],
        private: 0,
        data:{
          en:{
            title: '',
            content: '',
            cover_image_file_id: '',
          },
          hk:{
            title: '',
            content: '',
            cover_image_file_id: '',
          },
        },
        start_date: '',
        end_date: '',
        type: 3,
        mate :{
          url_hk : '',
          url_en : '',
          coupon_code : '',
          class_id : -1,
          product_id : -1,
        },
        tag_ids: []
      },
      useCouponList:[],
      couponOptionList: [],
      rules:{
        'img_upload': [
          {validator: checkImg}
        ],
        'tag': [
          {validator: checkTag}
        ],
        'title': [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        'content': [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        'date': [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        'url':[
          {validator: checkUrlRequired, trigger: ['change', 'blur']}
        ],
        'product':[
          {validator: checkProductRequired, trigger: ['change', 'blur']}
        ],
        'coupon_code':[
          {validator: checkCouponRequired, trigger: ['change', 'blur']}
        ],
      },
      tags: [],
      timer: null
    }
  },
  computed:{
    isDetail(){
      return false
      return this.promotionDetail != null
    },
    classList(){
      let res =[]
      res = this.couponOptionList.filter(item => {
        return item.id == this.formData.mate.product_id
      })
      if(res[0]){
        return res[0].class
      }
      return res
    },
    promotionID(){
      return this.$route.query.id
    }
  },
  created(){
    // this.network().getUseCouponList()
    this.network().couponOption()
    if(this.promotionID){
      this.network().getPromotionDetail(this.promotionID)
    }
  },
  methods: {
    bodyClick(e){
      if(this.$refs['input-tag'].tagListShow && !this.$refs['input-tag'].$el.contains(e.target)){
        this.$refs['input-tag'].tagListShow = false
      }
    },

    changeType(val){
      if(val == this.formData.type){
        return
      }
      this.formData.type = val
      const resetType3 = () => {
        this.formData.mate.url_hk = ''
        this.formData.mate.url_en = ''
      }
      const resetType4 = () => {
        this.formData.mate.coupon_code = ''
      }
      const resetType5 = () => {
        this.formData.mate.product_id = -1
        this.formData.mate.class_id = -1
      }
      if(val == 3){
        resetType4()
        resetType5()
      }else if(val == 4){
        resetType3()
        resetType5()
      }else{
        resetType3()
        resetType4()
      }
      this.$refs['form'].clearValidate(['mate.url_en','mate.url_hk','mate.product_id','mate.coupon_code'])
    },

    handleSetPrivate(){
      this.formData.private = this.formData.private ? 0 : 1
    },

    handlerUploadSuccess({ params, result, otherData }){
      this.network().uploadNewsImage({ params, result, otherData })
    },

    handleCancel(){
      this.$router.back()
    },

    getTag(tags){
      this.formData.tag_ids = []
      this.formData.tag_ids = JSON.parse(JSON.stringify(tags))
    },

    handleSave(){
      this.$refs['input-tag'].getTagId()
      this.$refs.form.validate((val, rule) => {
        if(val){
          let params = Object.assign({}, this.formData)
          params.start_date = params.date[0]
          params.end_date = params.date[1]
          delete params.date
          if(params.type == 3){
            delete params.mate.coupon_code
            delete params.mate.class_id
            delete params.mate.product_id
          }else if(params.type == 4){
            delete params.mate.url_hk
            delete params.mate.url_en
            delete params.mate.class_id
            delete params.mate.product_id
          }else{
            delete params.mate.url_hk
            delete params.mate.url_en
            delete params.mate.coupon_code
          }
          if(this.promotionID){
            this.network().updatePromotion(params)
          }else{
            this.network().newPromotion(params)
          }
        }else{
          this.scrollToValidDom(rule)
        }
      })
    },

    remoteMethod(query){
      let params = {
        search_text: query,
        hideLoading: true
      }
      if(this.timer){
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.network().getUseCouponList(params)
      }, 500)
    },
    handleFocus(){
      this.useCouponList = []
    },
    network(){
      return {
        getUseCouponList: async (params) => {
          let {data} = await getUseCouponList(params)
          this.useCouponList =data
        },

        couponOption: async () => {
          const {data} = await couponOption()
          this.couponOptionList = data.insurance
        },

        newPromotion: async (params) => {
          const {data} = await changePromotion('post', params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
          if(data.promotion_id){
            this.$router.back()
          }
        },

        uploadNewsImage: async ({ params, result, otherData }) => {
          const { data } = await uploadNewsImage(params)
          const { lang } = otherData
          const { url } = result
          this.$set(this.formData.data[lang], 'cover_image_file_id', data.image_id)
          this.$set(this.fileData[lang], 'thumb_url', url)
          this.$message({
            type: 'success',
            message: 'Upload Success'
          })

          this.$refs['form'].clearValidate([`data.${lang}.cover_image_file_id`])
        },

        getPromotionDetail: async (id) => {
          const { data } = await getPromotionDetail(id)
          Object.assign(this.formData, data)
          let tmp = {
            data:{}
          }
          tmp.data.en = data.data[0]
          tmp.data.hk = data.data[1]
          this.formData.data = {}
          this.formData.data = tmp.data
          this.formData.date.push(data.start_date)
          this.formData.date.push(data.end_date)
          if(data.mate.url){
            this.formData.mate.url_en = data.mate.url['en-US']
            this.formData.mate.url_hk = data.mate.url['zh-HK']
          }
          if(data.mate.coupon_code){
            this.formData.mate.coupon_code = data.mate.coupon_code
          }
          if(data.mate.product_id){
            this.formData.mate.product_id = data.mate.product_id
            this.formData.mate.class_id = data.mate.class_id
          }
          this.$set(this.fileData.en, 'thumb_url', data.data[0].cover_image_url)
          this.$set(this.fileData.hk, 'thumb_url', data.data[1].cover_image_url)
          this.tags = data.tag_ids
        },

        updatePromotion: async (params) => {
          const {status} = await changePromotion('patch', params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
          if(status == 200){
            this.$router.back()
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.icon{
  color:#409eff;
  cursor: pointer;
}
.clear:after{
  content: ' ';
  display: block;
  height: 0;
  clear: both;
}
.el-form-item{
  padding-bottom: 16px;
  span:first-child{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292E;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
}
.promotion-detail{
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #D5D8DE;
    background: white;
    cursor: pointer;
    margin-right: 10px;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    margin-right: 10px;
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .border-box{
    padding-bottom: 16px;
    border-bottom: 1px solid #E1E4E8;
    margin-bottom: 31px;
    .half{
      margin: 20px 30px;
      width: 350px;
      .classList{
        margin-top: 70px;
      }
      .flex{
        align-items: center;
        .flex-right{
          width: 100%;
          .el-select{
            width: 100%;
          }
        }
        .cb_tips{
          font-style: normal;
          font-family: Inter;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #24292E;
          margin: 0px 8px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
